import { deepCopy, deepCopyArray, isObject } from '@noda-lib/utils/handlers';
import { InjectionToken, inject } from '@angular/core';
function getDataFromDB(db, keys, copy = true) {
  const result = keys.reduce((accum, key) => accum[key], db);
  if (!copy) return result;
  return isObject(result) ? deepCopy(result) : Array.isArray(result) ? deepCopyArray(result) : result;
}
class StaticDB {
  constructor(db) {
    this.db = db;
  }
  get(keys, isCopy) {
    return getDataFromDB(this.db, keys, isCopy);
  }
}
const ROOT_DB = new InjectionToken('ROOT_DB');

/* eslint-disable @typescript-eslint/naming-convention */
function provideRootDB(db) {
  return {
    provide: ROOT_DB,
    useFactory() {
      return new StaticDB(db);
    }
  };
}
function useRootDB() {
  return inject(ROOT_DB);
}
function useDB(db) {
  return new StaticDB(db);
}

/**
 * Generated bundle index. Do not edit.
 */

export { StaticDB, getDataFromDB, provideRootDB, useDB, useRootDB };
